import { UserRoleCRM } from '@crm/types/userRoleCrm'

/**
 * The operational roles — the only ones that can hold CRM records, and so the
 * only ones a lead's responsible person may be. Mirrors the backend's
 * ACTIVE_ROLES.
 */
export const OPERATIONAL_ROLES = [
  UserRoleCRM.admin,
  UserRoleCRM.manager,
  UserRoleCRM.operator
]

/**
 * Roles allowed to set or change a lead's responsible person.
 *
 * Operators can never assign leads — not even their own, and not through bulk
 * actions — so this is deliberately an allowlist: a role gains assignment
 * affordances only by being named here. The backend rejects the write either
 * way; this list only decides which controls are worth rendering.
 */
export const LEAD_ASSIGNER_ROLES = [UserRoleCRM.admin, UserRoleCRM.manager]

/**
 * Roles allowed to create, edit or delete the global catalogs (nomenclatures
 * and products).
 *
 * Managers and operators read these catalogs but may not change them — the
 * backend answers their writes with a 403 — so they see the same screens
 * without any create, edit, delete or reorder controls.
 */
export const CATALOG_MANAGER_ROLES = [UserRoleCRM.admin]

/**
 * Roles allowed to see system configuration — mailbox connections and the
 * like. Distinct from CATALOG_MANAGER_ROLES: catalogs are readable by everyone
 * operational, whereas configuration is not visible at all below admin, even
 * where it happens to live under the nomenclatures routes.
 */
export const CONFIGURATION_ROLES = [UserRoleCRM.admin]
